<script>
import { useRouter } from 'vue-router'
//import { useAuthStatus } from '@/feature/AuthStatusFeature'
import { ref } from 'vue'

//component
//service
// import BzbsCategory from '@/core/Campaign/service/BzbsCategory.js';
import Topup2c2pService from '../../service/Topup2c2pService'
//feature
import { useLandingFlow } from '../../feature/LandingFlowFeature'
import { useLocale } from '../../feature/LocaleFeature';

export default {
    name: 'CategoryList',
    components: {

    },
    props: {
        categoryConfig:  { type: Object, required: true },
    },
    setup(props,ctx){
        const { lbl, localeCode } = useLocale()
        let catList = ref([])

        const router = useRouter()
        const { query, blobWebLanding } = useLandingFlow()

        //#region methods
        const initList = async () => {
            await getCategory();
        }

        const getCategory = () => {
            return new Promise((resolve) => {
                var categoryParam = props.categoryConfig.getParams();
                Topup2c2pService.apiGetCategory(query.value.token, categoryParam, query.value.appId, blobWebLanding.value, query.value.jwt).subscribe({
                    next: (categories) => {
                        
                        
                        catList.value = categories.map((cat) => {
                            cat.isShowAll = false
                            return cat
                        });
                        console.log(catList.value, 'categories')
                        resolve();
                        ctx.emit('onLoaded')
                    },
                    error: (err) => {
                        console.log(err)
                        resolve();
                        // errorApi(err);
                        ctx.emit('onLoaded')
                    },
                });
            });
        }

        const onSelectCat = (data) => {
            let catId = data?.id
            // let categoryName = localeCode.value == 1033 ? data.nameEn : data.nameTh
         
            if (catId == null) {
                router.replace('/topup2c2p/list')
            } else {
                router.replace('/topup2c2p/list/' + catId )
            }
        }

        const catName = (cat) => {
            return localeCode.value == 1033 ? cat.nameEn : cat.nameTh;
        }

        const toggleShowAll = (cat) => {
            cat.isShowAll = !cat.isShowAll
        }
        //#endregion methods

        //#region init
        initList()
        //#endregion init

        return {
            catList,
            catName,
            onSelectCat,
            toggleShowAll,
            lbl
        }
    },
}
</script>
<template>
    <div>
        <div class="bg-white mb-4 pt-2" v-for="(cat, k) in catList" :key="k">
            <div class="flex ">
                <div class="flex bg-a-orange-f9a601 pl-6 py-2 pr-4 rounded-r-full">
                    <img class="h-6 my-auto mr-2" :src="cat.image" >
                    <div class="text-white text-14 my-auto">{{catName(cat)}}</div>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-4 py-4 px-5 text-a-gray-4a4a4a">
                <template v-for="(subCat, j) in cat.subcats" 
                            :key="j" > 
                    <div v-if="cat.isShowAll || j < 2" @click="onSelectCat(subCat)"
                        class="border-a-gray-e5e5e5 border rounded-lg overflow-hidden">
                        <div class="subcate-image " :style="{'background-image': `url('${subCat.image}')`}"></div>
                        <div class="p-2 text-14 subcate-name">{{catName(subCat)}}</div>
                    </div>
                </template>
            </div>
            <div v-if="!cat.isShowAll && cat.subcats.length > 2" 
                @click="toggleShowAll(cat)"
                class="w-full flex pb-4">
                <div class="mr-0.5 ml-auto my-auto text-a-orange-f9a601 text-14">{{lbl.list.more}}</div>
                <img class="h-5 ml-0.5 mr-auto my-auto" src="../../assets/icon/more.svg" >
            </div>
            <div v-if="cat.isShowAll && cat.subcats.length > 2" 
                @click="toggleShowAll(cat)"
                class="w-full flex pb-4">
                <div class="mr-0.5 ml-auto my-auto text-a-orange-f9a601 text-14">{{lbl.list.less}}</div>
                <img class="h-5 ml-0.5 mr-auto my-auto" src="../../assets/icon/less.svg" >
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    @import "@/style/base/text.scss";
    .subcate-image {
        @include boxRatio($ratio: 100%);
    }

    .subcate-name {
        @extend %ellipsis-2;
        height: 50px;
    }
</style>
